import styled from '@emotion/styled';

export default styled('div')`
  font-size: 30px;
  color: red;
`;
